import React from "react";
import Workplace from "../../assets/images/workplace with computer monitor and diagram.svg";
import { useNavigate } from "react-router-dom";
import { Container, ImageContainer, P, Button } from "./styles";

export default function UnsetProfile() {
  const navigate = useNavigate();

  return (
    <Container>
      <ImageContainer>
        <img src={Workplace} alt="" />
      </ImageContainer>
      <P>This user has not setup their profile</P>
      <Button
        onClick={() => {
          navigate("/dashboard");
        }}
      >
        Go Back
      </Button>
    </Container>
  );
}
